import { hasClinicalCaseToShow } from '@/components/chat/bubbles/caseSummaryState';
import { isRecommendedCaseLayout, useCaseLayout } from '@/services/chat/caseLayoutSwitch';
import type { ClinicalCase } from '@/types/clinicalCase';

/**
 * Whether a message draws the recommended case layout: the layout is chosen and there is a case
 * section to draw. A message with extracted questions but no case, as when the viewer lacks
 * `clinical_cases_read`, keeps the questions section exactly as it was before the layout existed.
 * Temporary with `caseLayoutSwitch`.
 */
export function useRecommendedCaseLayout(clinicalCase: ClinicalCase | undefined): boolean {
  const layout = useCaseLayout();

  return hasClinicalCaseToShow(clinicalCase) && isRecommendedCaseLayout(layout);
}
